export default __webpack_public_path__ + "static/media/RampartOne-Regular.2a788921.ttf";